import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

export interface OrderHistoryDateRangeValidatorState {
    fromDateError: string;
    toDateError: string;
}

const initialState: OrderHistoryDateRangeValidatorState = {
    fromDateError: "",
    toDateError: "",
};
const OrderHistoryDateRangeValidatorReducer = {
    "Custom/OrderHistory/DateValidator/SetDateError": (
        draft: Draft<OrderHistoryDateRangeValidatorState>,
        action: {
            data: OrderHistoryDateRangeValidatorState;
        },
    ) => {
        draft.fromDateError = action.data.fromDateError;
        draft.toDateError = action.data.toDateError;
    },
};

export default createTypedReducerWithImmer(initialState, OrderHistoryDateRangeValidatorReducer);
